(function ($) {
    $(document).ready(function () {
        // FILTER FORM SUBMIT HANDLER
        $('#filter-form').one('submit', function (e) {
            e.preventDefault();
            let brandVal = $('select[name=brand]').val();
            if (('undefined' !== typeof brandVal && brandVal) && parseInt(brandVal) !== 0) {

                let brandSlug = $('select[name=brand] option:selected').data("slug")
                let modelSlug = $('select[name=model] option:selected').data("slug")
                $('select[name=brand]').remove();

                let slug = brandSlug;
                if (modelSlug)
                    slug = brandSlug + '/' + modelSlug
                $(this).attr('action', '/cars/' + slug);

                let modelVal = $('select[name=model]').val();
                let yearVal = $('input[name=year]').val();
                let priceVal = $('input[name=price]').val();
                let transmissionVal = $('select[name=transmission]').val();
                $('select[name=model]').remove();

                if ((parseInt(modelVal) === 0 || !modelVal)
                    && (parseInt(transmissionVal) === 0 || !transmissionVal)
                    && yearVal === ''
                    && priceVal === '') {

                    window.location.href = '/cars/' + brandSlug;
                    return false;
                }
            }
            $(this).submit();
        });

        // CLIENT BRAND CHANGE HANDLER
        $('select[name=clientbrand]').on('change', function () {
            let selectedBrand = $(this).val();
            $.ajax({
                method: "GET",
                url: `/api/dictionary/getModel/${selectedBrand}` ,
                success: function (data) {
                    $('select[name=clientmodel]').html(data);
                }
            })
        })
        let firstOption = $("select[name=brand] option:first");
        $('select[name=brand]').val(firstOption.val()).trigger('change');

        let transmissionInput = $('select[name=transmission]');

        if (transmissionInput.length > 0)
            $(transmissionInput).val(0).trigger('change');

        // BRAND INPUT CHANGE HANDLER
        $('select[name=brand]').on('change', function () {
            let selectedBrand = $('select[name=brand] option:selected').data("id")
            if (! window._allModels)
                return;

             let allModels = window._allModels;

            let parent = $(this).parents('form').first();
            let modelSelect = $('select[name=model]', parent)

            $(modelSelect)
                .find('option')
                .remove()
                .end()

            // if ($(this).parents('div.credit-step').length < 1)
            // {
            // $(modelSelect)
            //     .append($("<option></option>")
            //         .attr("value", "0")
            //         .text('Любая'));
            // // }

            // FILL MODELS SELECT INPUT

            let prevIndex = 0;
            let _val = '';
            allModels.forEach(function (value, i, arr) {
                if (parseInt(selectedBrand) === parseInt(value.brand_id) || value.id === 0) {
                    if (prevIndex === 0) {
                        _val = value.alter_slug;
                        prevIndex = i;
                    }

                    $(modelSelect)
                        .append($("<option></option>")
                            .attr("value", value.alter_slug)
                            .attr("data-slug", value.alter_slug)
                            .text(value.name));
                }
            });

            $(modelSelect).val(_val).trigger('change');

        });


        $('select[name=model]').on('change', function () {
            let eqSelect = $('select[name=version]');
            if ($(eqSelect).length > 0)
                getEquipmentData($(this));
        });
    })

    function getEquipmentData(modelSelect) {
        let model = $(modelSelect).select2('data');
        let brandSlug = $('select[name=brand] option:selected').val()
        if (model.length < 1)
            return;

        let versionSelect = $('select[name=version]')

        $(versionSelect)
            .find('option')
            .remove()
            .end()

        $.ajax({
            method: "GET",
            url: `/api/getEquipmentSets/${brandSlug}/${model[0].id}`,
            success: function (res) {

                // FILL EQUIPMENT_SET SELECT INPUT
                let eqs = res.data

                for (let key in eqs)
                {
                    $(versionSelect)
                        .append($("<option></option>")
                            .attr("value", key)
                            .text(eqs[key]));
                }
            }
        })
    }


})(jQuery);
